export const isFunction = (entity: unknown) => typeof entity === 'function'
export const isString = (entity: unknown) => typeof entity === 'string'
export const isNumber = (entity: unknown) => typeof entity === 'number'
